import {
  GET_PAGES,
  DELETE_PAGE,
  ADD_PAGE,
  EDIT_PAGE,
  LOADING_PAGE,
} from '../../actions/types';

const initalizeState = {
  pages:     [],
  loading:   true,
  error:     {},
  updatedAt: new Date(),
};

export default function (state = initalizeState, action) {
  const { type, payload } = action;
  switch (type) {
    case LOADING_PAGE:
      return {
        ...state,
        loading: true,
      };
    case GET_PAGES:
      return {
        ...state,
        pages:   payload.rows,
        loading: false,
      };
    case ADD_PAGE:
      return {
        ...state,
        pages:     [payload, ...state.pages],
        loading:   false,
        updatedAt: new Date(),
      };
    case EDIT_PAGE:
      return {
        ...state,
        pageInView: payload,
        loading:    false,
        updatedAt:  new Date(),
      };
    case DELETE_PAGE:
      return {
        ...state,
        pages:     state.pages.filter((page) => page.id !== payload),
        loading:   false,
        updatedAt: new Date(),
      };
    default:
      return state;
  }
}
